import { DatePicker } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import Config from "../../../../Config";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";

import { isEmptyObject } from "jquery";
import moment from "moment";
import FormsBloc from "../../../../bloc/forms_bloc";
import QuotationBloc from "../../../../bloc/quotation_bloc";
import UtilBloc from "../../../../bloc/util_bloc";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import AppModal from "../../../component/app_modal/app_modal";
import AppSelectButton from "../../../component/app_select_button/app_select_button";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import App_table from "../../../component/app_table/app_table";
import AppTextField from "../../../component/app_text_field/app_text_field";
import { isContainNumberOnly, nricValidation } from "../../../component/app_validation";
import AppFieldError from "../../../component/form/app_field_error/app_field_error";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import "./quotation_form.css";
import AppSteps from "../../../component/app_steps/app_steps2";
import App_header from "../../../component/app_header/app_header";
import Base_screen from "../../base/base_screen/base_screen";

const StepData = [
    {
        title: 'Personal Details'
    },
    {
        title: 'Financing Details'
    },
    {
        title: 'Takaful Details'
    },
    {
        title: 'Review and Submit'
    },
];

class PersonalDetailsForm extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            keyword: null,
            name: null,
            gender: null,
            idType: 'IC',
            addIdType: null,
            idNo: null,
            oldIcNo: null,
            birthCertNo: null,
            identityNo: null,
            passportNo: null,
            otherIdNo: null,
            dob: null,
            age: 0,
            occupationClass: null,
            occupationCode: null,
            occupation: null,
            natureOfBusiness: null,
            smokerStatus: null,
            dateOfQuotation: null,
            isSaveModalOpen: false,
            isDiscardModalOpen: false,
            isTooltipOpen: false,
            isEdit: false,
            errorMessage: 'Fill in the required field.',
            errorAgeMessage: 'ANB cannot be less than 18, and more than 66 years old',
            errorNricMessage: '',
            errorNameInd: false,
            erroridNoInd: false,
            errorIdentityNoInd: false,
            errorPassportNoInd: false,
            errorGenderInd: false,
            errorIdTypeInd: false,
            errorAddIdTypeInd: false,
            errorDobInd: false,
            errorAgeInd: false,
            errorOccupationClassInd: false,
            errorOccupationCodeInd: false,
            errorOccupationInd: false,
            errorNatureOfBusinessInd: false,
            errorSmokerStatusInd: false,
            errorDateOfQuotationInd: false,
            errorModal: false,
            editErrorModal: false,
            errorModalTitle: '',
            errorModalMessage: '',
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.getFormData();
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    async getOccupationData() {
        let occupationList = await FormsBloc.getOccupationList();
        this.setState({ occupationOpt: occupationList.data });
    }

    async getAdditionalIDTypeData() {
        let additionalIDTypeList = await FormsBloc.getAdditionalIDList();
        console.log('additionalIDTypeList', additionalIDTypeList)
        this.setState({ additionalIDTypeOpt: additionalIDTypeList.data });
    }

    async getOccupationClassData(occ, nob) {
        let occClass = await FormsBloc.getOccupationClassList(occ, nob);
        let occCode = await FormsBloc.getOccupationCodeList(occ, nob);
        this.setState({ occupationClass: occClass.data[0], occupationCode: occCode.data[0] });
    }

    async getNatureOfBusinessData(occ) {
        let nobList = await FormsBloc.getNatureOfBusiness(occ);
        this.setState({ nobOpt: nobList.data });
    }

    async getFormData() {
        this.setState({ loading: true });
        let formData = await QuotationBloc.getFormDetailQuotation(this.getQuotationId(), Config.quotation.formLabelMapping.personalDetails.label);

        await this.getOccupationData();
        await this.getAdditionalIDTypeData();
        if (!isEmptyObject(formData)) {
            //Check is Editable 
            let editable = await QuotationBloc.editGeneratedQuotation(this.getQuotationId());
            if (editable.success) {
                this.setState({
                    loading: false,
                    isEdit: true,
                    formData: formData,
                    name: formData.name,
                    gender: formData.gender,
                    idType: formData.typeId,
                    idNo: formData.idNo,
                    otherIdNo: formData.otherIdNo,
                    dob: formData.dob,
                    age: formData.anb,
                    occupationClass: formData.occupationClass,
                    occupationCode: formData.occupationCode,
                    natureOfBusiness: formData.natureOfBusiness,
                    smokerStatus: formData.smokerStatus,
                    dateOfQuotation: formData.dateOfQuotation,
                    addIdType: formData.addIDType,
                    oldIcNo: formData.oldIcNo,
                    birthCertNo: formData.birthCertNo,
                }, () => {
                    this.handleOccupationChange(formData.occupation);
                })
            } else {
                this.setState({
                    loading: false,
                    editErrorModal: true,
                })
            }
        } else {
            this.setState({ loading: false })
        }

    }

    handleNameChange = (name) => {
        this.setState({
            name: name,
            errorNameInd: UtilBloc.isNullOrEmpty(name)
        });
    }
    handleGenderChange = (gender) => {
        this.setState({
            gender: gender,
            errorGenderInd: UtilBloc.isNullOrEmpty(gender)
        });
    }
    handleIdTypeChange = (idType) => {
        this.setState({
            idType: idType,
            idNo: null,
            otherIdNo: null,
            errorIdTypeInd: UtilBloc.isNullOrEmpty(idType)
        });
    }

    handleAddIdTypeChange = (addIdType) => {
        this.setState({
            addIdType: addIdType,
            oldIcNo: null,
            birthCertNo: null,
            errorAddIdTypeInd: UtilBloc.isNullOrEmpty(addIdType)
        });
    }

    getBirthdayFromID(idNo) {
        const Year = idNo.substring(0, 2);
        const Month = idNo.substring(2, 4);
        const Day = idNo.substring(4, 6);

        var cutoff = new Date().getFullYear() - 2000;
        var dob = Day + "/" + Month + "/" + (Year > cutoff ? "19" : "20") + Year;

        this.handleAgeCalculate((Year > cutoff ? "19" : "20") + Year, Month, Day);
        return moment(dob, 'DD/MM/YYYY');
    }

    handleNRICChange = (idNo) => {
        if (idNo) {
            if (isContainNumberOnly(idNo) && idNo.length > 5) {
                let dob = this.getBirthdayFromID(idNo);
                this.setState({
                    idNo: idNo,
                    dob: moment(dob, 'DD/MM/YYYY')
                });
            } else {
                this.setState({ idNo: idNo })
            }
        } else {
            this.setState({
                idNo: idNo,
                dob: null,
                age: null,
                erroridNoInd: UtilBloc.nricValidation(idNo)
            });
        }

    }

    handleOldICChange = (idNo) => {
        if (idNo) {
            this.setState({ oldIcNo: idNo })
        } else {
            this.setState({
                oldIcNo: idNo,
                errorOldIdNoInd: UtilBloc.nricValidation(idNo)
            });
        }
    }

    handleBirthCertNoChange = (certNo) => {
        if (certNo) {
            this.setState({ birthCertNo: certNo })
        } else {
            this.setState({
                birthCertNo: certNo,
                errorBirthCertNoInd: UtilBloc.isNullOrEmpty(certNo)
            });
        }
    }

    handleOtherIdNoChange = (idNo) => {
        if (this.state.idType == 'Police/Army' && idNo.length > 5) {
            if (isContainNumberOnly(idNo)) {
                let dob = this.getBirthdayFromID(idNo);
                this.setState({
                    otherIdNo: idNo,
                    dob: moment(dob, 'DD/MM/YYYY')
                });
            } else {
                this.setState({ otherIdNo: idNo });
            }

        } else if (!idNo && this.state.idType == 'Police/Army') {
            this.setState({
                otherIdNo: idNo,
                dob: null,
                age: null,
                erroridNoInd: UtilBloc.nricValidation(idNo)
            });
        } else {
            this.setState({
                otherIdNo: idNo,
                erroridNoInd: UtilBloc.isNullOrEmpty(idNo)
            });
        }

    }
    handleDobChange = (date) => {
        if ((date && date._d) || (date && date._i)) {
            const today = new Date();
            const birthDate = date._d || date._i;
            let anb = today.getFullYear() - birthDate.getFullYear();
            if (
                today.getMonth() > birthDate.getMonth() ||
                (today.getMonth() === birthDate.getMonth() &&
                    today.getDate() >= birthDate.getDate())
            ) {
                anb++;
            }

            if (18 <= anb && anb <= 66) {
                this.setState({ dob: date, age: anb, errorAgeInd: false });
            } else {
                this.setState({ errorAgeInd: true })
            }

        }
        else {
            this.setState({ dob: null, age: 0 });
        }

    }
    handleAgeCalculate(year, month, day) {
        const today = new Date();
        let anb = today.getFullYear() - year;
        if (
            today.getMonth() > month ||
            (today.getMonth() === month &&
                today.getDate() >= day)
        ) {
            anb++;
        }

        if (18 <= anb && anb <= 66) {
            this.setState({ age: anb, errorAgeInd: false });
        } else {
            this.setState({ errorAgeInd: true })
        }
    }
    handleOccupationClassChange = (occupationClass) => {
        if (this.state.natureOfBusiness && this.state.occupation) {
            this.getOccupationClassData(this.state.occupation, this.state.natureOfBusiness);
        } else {
            this.setState({ occupationClass: occupationClass });
        }
        this.setState({
            errorOccupationClassInd: UtilBloc.isNullOrEmpty(occupationClass)
        })
    }

    handleOccupationCodeChange = (occupationCode) => {
        if (this.state.natureOfBusiness && this.state.occupation) {
            this.getOccupationClassData(this.state.occupation, this.state.natureOfBusiness);
        } else {
            this.setState({ occupationClass: occupationCode });
        }
        this.setState({
            errorOccupationCodeInd: UtilBloc.isNullOrEmpty(occupationCode)
        })
    }

    handleOccupationChange = (occupation) => {
        this.getNatureOfBusinessData(occupation);
        if (occupation && this.state.natureOfBusiness) {
            this.getOccupationClassData(occupation, this.state.natureOfBusiness);
        }
        this.setState({
            occupation: occupation,
            errorOccupationInd: UtilBloc.isNullOrEmpty(occupation)
        });
    }
    handleNatureOfBusinessChange = (business) => {
        if (business && this.state.occupation) {
            this.getOccupationClassData(this.state.occupation, business);
        }
        this.setState({
            natureOfBusiness: business,
            errorNatureOfBusinessInd: UtilBloc.isNullOrEmpty(business)
        });
    }
    handleSmokerStatusChange = (status) => {
        this.setState({
            smokerStatus: status,
            errorSmokerStatusInd: UtilBloc.isNullOrEmpty(status)
        });
    }
    handleQuotationDateChange = (date) => {
        this.setState({
            dateOfQuotation: date,
            errorDateOfQuotationInd: UtilBloc.isNullOrEmpty(date)
        });
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true })
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false })
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true })
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false })
    }

    handleTooltipOpen = () => {
        this.setState({ isTooltipOpen: true })
    }
    handleTooltipClose = () => {
        this.setState({ isTooltipOpen: false })
    }

    getBackToQuotationDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
    }

    handleStopWithoutSaving = () => {
        this.getBackToQuotationDashboard();
    }

    handleValidateForm() {

        const {
            name, gender, idType, idNo, dob, occupationClass, occupation, occupationCode,
            natureOfBusiness, smokerStatus, dateOfQuotation, otherIdNo, addIdType, oldIcNo, birthCertNo
        } = this.state;

        this.setState({
            errorNameInd: UtilBloc.isNullOrEmpty(name) ? true : false,
            errorGenderInd: UtilBloc.isNullOrEmpty(gender) ? true : false,
            errorIdTypeInd: UtilBloc.isNullOrEmpty(idType) ? true : false,
            erroridNoInd:
                idType === 'IC' ? UtilBloc.nricValidation(idNo) :
                    idType === 'Police/Army' ? UtilBloc.nricValidation(otherIdNo) :
                        UtilBloc.isNullOrEmpty(otherIdNo),
            errorNricMessage: nricValidation(idNo),
            errorDobInd: UtilBloc.isNullOrEmpty(dob) ? true : false,
            errorOccupationClassInd: UtilBloc.isNullOrEmpty(occupationClass) ? true : false,
            errorOccupationCodeInd: UtilBloc.isNullOrEmpty(occupationCode) ? true : false,
            errorOccupationInd: UtilBloc.isNullOrEmpty(occupation) ? true : false,
            errorNatureOfBusinessInd: UtilBloc.isNullOrEmpty(natureOfBusiness) ? true : false,
            errorSmokerStatusInd: UtilBloc.isNullOrEmpty(smokerStatus) ? true : false,
            errorDateOfQuotationInd: UtilBloc.isNullOrEmpty(dateOfQuotation) ? true : false,
            errorAddIdTypeInd: addIdType ? addIdType === 'oldIcNo' ? UtilBloc.isNullOrEmpty(oldIcNo) : addIdType === 'birthCertNo' ? UtilBloc.isNullOrEmpty(birthCertNo) : false : false,
        })
        if (
            !UtilBloc.isNullOrEmpty(name) && !UtilBloc.isNullOrEmpty(gender) && !UtilBloc.isNullOrEmpty(idType) && (idType == 'IC' ? !UtilBloc.nricValidation(idNo) : idType === 'Police/Army' ? !UtilBloc.nricValidation(otherIdNo) : !UtilBloc.isNullOrEmpty(otherIdNo))
            && !UtilBloc.isNullOrEmpty(dob) && !UtilBloc.isNullOrEmpty(occupation) && !UtilBloc.isNullOrEmpty(occupationClass) && !UtilBloc.isNullOrEmpty(occupationCode) && !UtilBloc.isNullOrEmpty(natureOfBusiness) && !UtilBloc.isNullOrEmpty(smokerStatus) && !UtilBloc.isNullOrEmpty(dateOfQuotation) &&
            (addIdType ? addIdType === 'oldIcNo' ? !UtilBloc.isNullOrEmpty(oldIcNo) : addIdType === 'birthCertNo' ? !UtilBloc.isNullOrEmpty(birthCertNo) : true : true)
        ) {
            return true;
        } else {
            return false;
        }
    }

    handleSaveCurrentStep() {
        this.handleFormSubmit('save');
    }

    handleNextStep() {
        const isValidate = this.handleValidateForm();
        if (isValidate) {
            this.handleFormSubmit('next');
        }

    }

    async handleFormSubmit(type) {
        let data = Config.quotation.formDataMapping.personalDetails;
        this.setState({ loading: true });
        data.name = this.state.name ? this.state.name : '';
        data.gender = this.state.gender ? this.state.gender : '';
        data.idType.code = this.state.idType ? this.state.idType : '';
        data.idNo = this.state.idType == 'IC' && this.state.idNo ? this.state.idNo : '';
        data.otherIdNo = this.state.idType != 'IC' && this.state.otherIdNo ? this.state.otherIdNo : '';
        data.dob = this.state.dob ? moment(this.state.dob._d).format('YYYYMMDD') : '';
        data.anb = this.state.age ? this.state.age.toString() : '';
        data.occupationClass = this.state.occupationClass ? this.state.occupationClass : '';
        data.occupationGroupCode = this.state.occupationCode ? this.state.occupationCode : '';
        data.occupation = this.state.occupation || '';
        data.natureOfBusiness = this.state.natureOfBusiness || '';
        data.smoker = this.state.smokerStatus ? this.state.smokerStatus : '';
        data.quotationDate = this.state.dateOfQuotation ? moment(this.state.dateOfQuotation).format('YYYYMMDD') : '';
        data.addIDType = this.state.addIdType || '';
        if (this.state.addIdType == 'oldIcNo') {
            data.oldIcNo = this.state.oldIcNo ? this.state.oldIcNo : '';
        } else if (this.state.addIdType == 'birthCertNo') {
            data.birthCertNo = this.state.birthCertNo ? this.state.birthCertNo : '';
        }

        let response = await QuotationBloc.saveForm(this.getQuotationId(), 'PERSONAL_DETAILS', data);

        if (response.success) {
            type == 'next' ?
                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation_financial_details}/${this.getQuotationId()}` :
                this.getBackToQuotationDashboard();
        } else {
            this.setState({
                loading: false,
                errorModal: true,
                errorTitle: 'Upload Failed',
                errorModalMessage: response.message
            })
        }
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={true}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Next'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => { this.handleNextStep() }}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }

    renderOccupationTableList = () => {
        return (
            <div className="w-100 mt-4" style={{ height: '60vh', overflowY: 'scroll' }}>
                <App_table
                    data={Config.occupationClassData.occupationTableData}
                    collumn={Config.occupationClassData.occupationTableColumn}
                    totalData={100}
                />
            </div>
        )
    }

    name = () => {
        return (
            <AppTextField
                title={'Name'}
                type={'text'}
                placeholder={'Enter your full name...'}
                value={this.state.name || this.state.formData?.name}
                onChange={this.handleNameChange}
                onValidate={(value) => { return UtilBloc.isNullOrEmpty(value) }}
                error={this.state.errorNameInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    gender = () => {
        return (
            <AppSelectField
                title={'Gender'}
                value={this.state.gender}
                placeholder={'Select gender...'}
                options={Config.quotation.optionItem.gender}
                onChange={this.handleGenderChange}
                onValidate={(value) => { return UtilBloc.isNullOrEmpty(value) }}
                error={this.state.errorGenderInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    idType = () => {
        return (
            <AppSelectField
                title={'ID Type'}
                value={this.state.idType}
                placeholder={'Select ID Type...'}
                options={Config.quotation.optionItem.idType}
                onChange={this.handleIdTypeChange}
                error={this.state.errorIdTypeInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    idNo = () => {
        return (
            <AppTextField
                title={
                    this.state.idType == 'IC' ? 'IC No.' :
                        this.state.idType == 'Police/Army' ? 'Identify No.' :
                            'Passport No.'
                }
                placeholder={
                    this.state.idType == 'IC' || this.state.idType == 'Police/Army' ?
                        'YYMMDDBP###G' : 'Enter your identify number...'
                }
                type={'text'}
                value={this.state.idType == 'IC' ? this.state.idNo : this.state.otherIdNo}
                onChange={
                    this.state.idType == 'IC' ?
                        this.handleNRICChange : this.handleOtherIdNoChange
                }
                onValidate={(value) => {
                    if (this.state.idType == 'IC' || this.state.idType == 'Police/Army') {
                        return UtilBloc.nricValidation(value)
                    } else {
                        return UtilBloc.isNullOrEmpty(value)
                    }

                }}
                // error={this.state.erroridNoInd}
                errorMessage={
                    this.state.idType == 'IC' || this.state.idType == 'Police/Army' ?
                        nricValidation(this.state.idNo) : this.state.errorMessage
                }
            />
        )
    }


    addIdType = () => {
        return (
            <AppSelectField
                title={'Additional ID Type'}
                value={this.state.addIdType}
                placeholder={'Select...'}
                options={Config.quotation.optionItem.additionalID}
                onChange={this.handleAddIdTypeChange}
            />
        )
    }

    oldIdNo = () => {
        return (
            <AppTextField
                title={
                    this.state.addIdType == 'oldIcNo' ? 'Old IC No.' :
                        'Birth Certificate ID'
                }
                placeholder={
                    this.state.addIdType == 'oldIcNo' ?
                        'YYMMDDBP###G' : 'Enter your birth certificate number...'
                }
                type={'text'}
                value={this.state.addIdType == 'oldIcNo' ? this.state.oldIcNo : this.state.birthCertNo}
                onChange={
                    this.state.addIdType == 'oldIcNo' ?
                        this.handleOldICChange : this.handleBirthCertNoChange
                }
                error={this.state.errorAddIdTypeInd}
                onValidate={(value) => {
                    return UtilBloc.isNullOrEmpty(value)
                }}
                // error={this.state.erroridNoInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    dob = () => {
        return (
            <div className="mt-1">
                Date of Birth
                <DatePicker
                    onChange={(d) => this.handleDobChange(d)}
                    style={{ height: '48px', width: '100%', marginTop: '1vh' }}
                    placeholder="DD/MM/YYYY"
                    format={'DD/MM/YYYY'}
                    value={this.state.dob}
                    disabled={
                        this.state.idType == 'IC' || this.state.idType == 'Police/Army' ?
                            true : false
                    }
                    renderExtraFooter={() =>
                        <p style={{ lineHeight: '16px' }}>ANB cannot be more than 66, & less than 18 years old. Please select a year between 1958 - 2005</p>
                    }
                />
                {
                    this.state.errorDobInd &&
                    <AppFieldError text={this.state.errorMessage} />
                }
            </div>
        )
    }

    age = () => {
        return (
            <AppTextField
                title={'Age Next Birthday(18 - 66)'}
                type={'text'}
                placeholder={this.state.age}
                disabled={true}
                value={this.state.age}
                error={this.state.errorAgeInd}
                errorMessage={this.state.errorAgeMessage}
            />
        )
    }

    occupationClass = () => {
        return (
            <AppSelectField
                title={'Occupation Class'}
                value={this.state.occupationClass}
                placeholder={'Select occupation class...'}
                options={Config.quotation.optionItem.occupationClass}
                handleTooltipOpen={this.handleTooltipOpen}
                onChange={this.handleOccupationClassChange}
                error={this.state.errorOccupationClassInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    occupationCode = () => {
        return (
            <AppSelectField
                title={'Occupation Code'}
                value={this.state.occupationCode}
                // tooltipEnabled={true}
                placeholder={'Select occupation code...'}
                options={this.state.occupationCode ? [{ label: this.state.occupationCode, value: this.state.occupationCode }] : []}
                handleTooltipOpen={this.handleTooltipOpen}
                onChange={this.handleOccupationCodeChange}
                error={this.state.errorOccupationCodeInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    occupation = () => {
        return (
            <AppSelectField
                title={'Occupation'}
                value={this.state.occupation}
                placeholder={'Select occupation...'}
                options={this.state.occupationOpt}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                showSearch={true}
                onChange={this.handleOccupationChange}
                error={this.state.errorOccupationInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    natureOfBusiness = () => {
        return (
            <AppSelectField
                title={'Nature of Business'}
                value={this.state.natureOfBusiness}
                placeholder={'Select nature of business...'}
                options={this.state.nobOpt}
                onChange={this.handleNatureOfBusinessChange}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                showSearch={true}
                error={this.state.errorNatureOfBusinessInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    smokerStatus = () => {
        return (
            <AppSelectButton
                title={'Smoker Status'}
                value={this.state.smokerStatus}
                handleNegativePress={() => this.handleSmokerStatusChange('No')}
                handlePositivePress={() => this.handleSmokerStatusChange('Yes')}
                error={this.state.errorSmokerStatusInd}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    dateOfQuotation = () => {
        return (
            <>
                Date of Quotation
                <DatePicker
                    onChange={(d) => this.handleQuotationDateChange(d)}
                    style={{ height: '48px', width: '100%', marginTop: '1vh' }}
                    value={this.state.dateOfQuotation}
                    placeholder="DD/MM/YYYY"
                    format={'DD/MM/YYYY'}
                    error={this.state.errorDateOfQuotationInd}
                    errorMessage={this.state.errorMessage}
                />
                {
                    this.state.errorDateOfQuotationInd &&
                    <AppFieldError text={this.state.errorMessage} />
                }
            </>
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%' }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={0}
                                    items={StepData}
                                />
                            </div>

                        </App_header>
                        {this.state.loading && this.loadingContent()}
                        <div
                            style={{
                                marginTop: 110,
                                paddingLeft: 42,
                                paddingRight: 42,
                                paddingBottom: 150
                            }}
                        >
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={'Step 1 - Personal Details'}
                                    description={<span style={{ color: 'red', fontStyle: 'italic' }}>All fields are required</span>}
                                    handleBack={() => this.handleSaveModalOpen()}
                                />
                            </div>

                            <div className="w-100 form_container m-2" >
                                <div className="row m-0 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                        {this.name()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0  ">
                                        {this.gender()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                        {this.idType()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.idNo()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                        {this.addIdType()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.state.addIdType && this.oldIdNo()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                        {this.dob()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                        {this.age()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                        {this.occupation()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.natureOfBusiness()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                        {this.occupationCode()}
                                    </div>
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.occupationClass()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-2 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.smokerStatus()}
                                    </div>
                                </div>
                                <div className="row m-0 mt-4 w-100">
                                    <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                        {this.dateOfQuotation()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.renderBottomBar()}
                        <AppModal
                            open={this.state.isTooltipOpen}
                            handleModalClose={this.handleTooltipClose}
                            width={'70%'}
                            title={'Occupation Group & Class Guide'}
                            closable={true}
                        >
                            {this.renderOccupationTableList()}
                        </AppModal>
                        <AppModal
                            open={this.state.isSaveModalOpen}
                            handleModalClose={this.handleSaveModalClose}
                            width={'50%'}
                            title={'Do you want to stop?'}
                            subtitle={'If you stop without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={() => this.handleStopWithoutSaving()}
                            handlePositivePress={() => this.handleSaveCurrentStep()}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.isDiscardModalOpen}
                            handleModalClose={this.handleDiscardModalClose}
                            width={'50%'}
                            title={'Do you want to discard?'}
                            subtitle={'If you discard without saving, you will loose any progress you’ve made.'}
                            negativeButtonText={'Stop without Saving'}
                            positiveButtonText={'Save & Close'}
                            handleNegativePress={() => this.handleStopWithoutSaving()}
                            handlePositivePress={() => this.handleSaveCurrentStep()}
                            closable={false}
                        />
                        <AppModal
                            open={this.state.editErrorModal}
                            handleModalClose={() => this.setState({ editErrorModal: false })}
                            width={'50%'}
                            title={'Cannot be Edit/Update'}
                            subtitle={'This quotation cannot be update or edit'}
                            positiveButtonText={'Back'}
                            handlePositivePress={() =>
                                window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.quotation}`
                            }
                            closable={false}
                        />
                        <AppModal
                            open={this.state.errorModal}
                            handleModalClose={() => this.setState({ errorModal: false })}
                            width={'50%'}
                            title={this.state.errorModalTitle}
                            subtitle={this.state.errorModalMessage}
                            positiveButtonText={'Close'}
                            handlePositivePress={() => this.setState({ errorModal: false })}
                            closable={false}
                        />
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(PersonalDetailsForm));
